module.exports = __webpack_public_path__ + "static/extra_5_mobile-35bf702d7acb91f2286d26c0db455fe4.jpg";